import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';
import { SERVICES } from '../data/servicesMeta';
import serviceContent from '../data/serviceContent.json';

const ServicesOverview = ({ showHeading = true }) => {
  const { t } = useTranslation();
  const { localizedPath, locale } = useLocale();

  return (
    <section className="section bg-white" data-testid="services-overview">
      <div className="container">
        {showHeading && (
          <div className="text-center mb-14">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A0A0A] mb-4">
              {t('servicesOverview.title', 'What We Build')}
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {t('servicesOverview.subtitle', 'End-to-end software development services for ambitious businesses.')}
            </p>
          </div>
        )}

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {SERVICES.map((svc) => {
            const Icon = svc.icon;
            const localizedName = serviceContent[svc.slug]?.[locale]?.h1 || svc.name;
            return (
              <Link
                key={svc.slug}
                to={localizedPath(`service/${svc.slug}`)}
                className="group bg-gradient-to-br from-blue-50 to-white p-7 rounded-2xl border border-gray-200 hover:border-[#0B3F84] hover:shadow-lg transition-all"
                data-testid={`service-card-${svc.slug}`}
              >
                <div className="w-12 h-12 bg-[#0B3F84] rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <Icon className="text-white" size={24} />
                </div>
                <h3 className="text-xl font-bold text-[#0A0A0A] mb-2">{localizedName}</h3>
                <p className="text-gray-600 text-sm mb-4">{t(`servicesOverview.taglines.${svc.slug}`, svc.tagline)}</p>
                <span className="text-[#0B3F84] text-sm font-semibold inline-flex items-center gap-1">
                  {t('servicesOverview.learnMore', 'Learn more')}
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
